"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _get = _interopRequireDefault(require("lodash/get"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _connectors = require("./connectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Builds a React component based on a describing object.
 * Will recurse on `componentDocument.children`
 *
 * @param {object}  componentDocument - describes a component to be built
 *   @param {string}  type - name of component to be built
 *   @param {object}  props - props to be passed to component
 *   @param {object}  dataDependency - object declaring type and params for data needed
 *   @param {object}  dataSources - [DEPRECATED] table with paths to feed props from the store
 *   @param {array}   children - array of component documents to be built and passed as children
 *   @param {string}  requestedIntegration - [DEPRECATED] key name of integration in integrations
 * @param {object} componentLibrary - mapping of component names to component functions
 * @param {object} integrationsLibrary - [DEPRECATED] map of integrations
 *
 * @returns {object} component
 */
var Composition = function Composition(_ref) {
  var componentDocument = _ref.componentDocument,
      componentLibrary = _ref.componentLibrary,
      integrationsLibrary = _ref.integrationsLibrary;
  var type = componentDocument.type,
      dataDependency = componentDocument.dataDependency,
      dataSources = componentDocument.dataSources,
      requestedIntegration = componentDocument.requestedIntegration;
  var props = componentDocument.props;
  var childrenToPassDown = null;
  var children = Array.isArray(componentDocument) ? componentDocument : componentDocument.children; // Recursively render any children, depth-first.
  // Return array of child elements or single element if only one child.
  // Some components accept only a single child rather than an array of children.

  if (children) {
    var renderedChildren = children.map(function (child, index) {
      return _react.default.createElement(Composition, {
        componentDocument: child,
        componentLibrary: componentLibrary,
        integrationsLibrary: integrationsLibrary,
        key: (0, _get.default)(child, 'id', index)
      });
    });
    childrenToPassDown = renderedChildren.length === 1 ? renderedChildren[0] : renderedChildren;
  } // if we have an array of components but no parent node, wrap the array of children in a fragment


  if (Array.isArray(componentDocument)) {
    return _react.default.createElement(_react.Fragment, null, childrenToPassDown);
  } // Compose this component


  var Component = componentLibrary[type]; // Is this component in the library?

  if (typeof Component !== 'function') {
    throw new Error("componentLibrary[".concat(type, "] is not a function.\n      Check the import of ").concat(type, " in the componentLibrary."));
  }

  if (dataDependency) {
    Component = (0, _connectors.connectToDataDependency)(dataDependency, Component, type); // extend component props to pass down relevant data-related information

    props = _objectSpread({}, props, {
      requestedIds: (0, _connectors.unpackIds)((0, _get.default)(dataDependency, 'data.ids', []))
    }, (0, _omit.default)((0, _get.default)(dataDependency, 'data', {}), 'ids'));
  } else if (dataSources) {
    Component = (0, _connectors.connectToDataSources)(dataSources)(Component);
  } else if (requestedIntegration) {
    // Error checks
    if (!integrationsLibrary) {
      throw new Error("No integrations library was provided, but an integration was requested on ".concat(type, "."));
    }

    if (typeof integrationsLibrary.get !== 'function') {
      throw new Error("integrationsLibrary must supply a get() function. Integration requested by ".concat(type, "."));
    }

    if (!integrationsLibrary.get(requestedIntegration)) {
      throw new Error("".concat(requestedIntegration, " not found in integrationsLibrary"));
    }

    var _integrationsLibrary$ = integrationsLibrary.get(requestedIntegration),
        mapStateToProps = _integrationsLibrary$.mapStateToProps,
        mapDispatchToProps = _integrationsLibrary$.mapDispatchToProps,
        mergeProps = _integrationsLibrary$.mergeProps,
        options = _integrationsLibrary$.options,
        injectProps = _integrationsLibrary$.injectProps; // State connections


    if (mapStateToProps || mapDispatchToProps) {
      Component = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps, options)(Component);
    }

    if (injectProps) {
      props = _objectSpread({}, props, injectProps);
    }
  }

  return _react.default.createElement(Component, props, childrenToPassDown);
};

Composition.propTypes = {
  // componentDocument can be either a single node (potentially with children) or an array of nodes
  componentDocument: _propTypes.default.oneOfType([_propTypes.default.shape({
    /* eslint-disable react/no-unused-prop-types */
    id: _propTypes.default.string,
    type: _propTypes.default.string,
    props: _propTypes.default.object,
    children: _propTypes.default.array,
    requestedIntegration: _propTypes.default.string
    /* eslint-enable react/no-unused-prop-types */

  }), _propTypes.default.arrayOf(_propTypes.default.shape({
    /* eslint-disable react/no-unused-prop-types */
    id: _propTypes.default.string,
    type: _propTypes.default.string,
    props: _propTypes.default.object,
    children: _propTypes.default.array,
    requestedIntegration: _propTypes.default.string
    /* eslint-enable react/no-unused-prop-types */

  }))]).isRequired,
  // We can't define a shape for the components and their integrations
  componentLibrary: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  integrationsLibrary: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};
Composition.defaultProps = {
  integrationsLibrary: {}
};
var _default = Composition;
exports.default = _default;